export default __webpack_public_path__ + "0386122303e05d0fbe831e5d4bb53fa8.svg";